/* istanbul ignore file */
import Token from '@web/common/token'
import client, { ApiVersion } from '../client'
import HeaderMapper from '@web/mapper/HeaderMapper'
import Mapper from '@web/mapper/Mapper'
import UserMapper from '@web/mapper/UserMapper'

export default class Auth {
  static login ({
    code,
    method,
    phone,
    email,
    useSms
  }: {
    code?: string,
    method: 'phone' | 'email' | 'vk',
    phone?: string,
    email?: string,
    useSms?: boolean
  }) {
    return client.post('/auth/login', {
      code,
      method,
      phone,
      email,
      use_sms: useSms
    }, ApiVersion.v2)
      .then((response) => {
        if (!response.data.errors?.length) {
          Token.set(response.data.data.token)
          const user = response.data.data.user ? UserMapper.toClient(response.data.data.user) : null
          return {
            data: {
              user,
              channel: response.data.data.channel,
              maskedDestination: response.data.data.masked_destination
            },
            headers: HeaderMapper.toClient(response.headers)
          }
        } else {
          throw { errors: response.data.errors } // eslint-disable-line
        }
      }).catch((error) => {
        return error.response.json().then((data) => {
          return Promise.reject(data)
        })
      })
  }

  static verifyOtpLogin ({
    code,
    phone,
    email,
    useSms
  }: {
    code?: string,
    phone?: string,
    email?: string,
    useSms?: boolean
  }) {
    return client.post('/auth/verify-otp-login', {
      code,
      phone,
      email,
      use_sms: useSms
    }, ApiVersion.v2)
      .then((response) => {
        if (!response.data.errors?.length) {
          Token.set(response.data.data.token)
          const user = response.data.data.user ? UserMapper.toClient(response.data.data.user) : null
          return {
            data: user,
            headers: HeaderMapper.toClient(response.headers)
          }
        } else {
          throw { errors: response.data.errors } // eslint-disable-line
        }
      }).catch((error) => {
        return error.response.json().then((data) => {
          return Promise.reject(data)
        })
      })
  }

  static getAuthOptions () {
    return client.get('/auth/options', { apiVersion: ApiVersion.v2 })
      .then((response) => {
        return {
          data: Mapper.toClient(response.data.data),
          headers: HeaderMapper.toClient(response.headers)
        }
      })
  }
}
